import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';
import { catalogModule as catalog } from '@/store/question/catalogModule';
import { questionTypeModule as questionType } from '@/store/question/questionTypeModule';
import { basicTypeModule as basicType } from '@/store/question/basicTypeModule';
import { questionManageModule as questionManage } from '@/store/question/questionManageModule';

const URL = {
  VERSION_LIST: '/dh-datamaint/version/listAll',
  SUBMIT_VERSION: '/dh-datamaint/version/submit',
  VERSION_LIST_SELF: '/dh-datamaint/version/listSelf'
};

class QuestionModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {};

  modules = {
    catalog,
    questionType,
    basicType,
    questionManage
  };
}

export const questionModule = new QuestionModule();
